import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';


//Function to split data 
const splitPrSpo2PiData = (PrSp02PiData) => {
    
    var s_Cleaned_Data = PrSp02PiData.replace("S", "");
    var splitted_spo2_PrPi_Data = s_Cleaned_Data.split("P");
    
    var splitted_Pr_Pi_Data = splitted_spo2_PrPi_Data[1].split('I');

    var splitted_Data = [splitted_spo2_PrPi_Data[0], splitted_Pr_Pi_Data[0], splitted_Pr_Pi_Data[1]]

    return splitted_Data;

}


const formatAndMergeOximeterData = (fullLoad, oldPulseOximeterData, newPulseOximeterData) => {

    let local_data = {'pulseRate': [], 'sp02': [], 'pi': []};
    let isANewDateValue = "";

    // Reset data if new load
    if (fullLoad){
        oldPulseOximeterData = []
    }
    if (oldPulseOximeterData !== undefined){
        Utils.mergeBasicOldData(oldPulseOximeterData.pulseRate, local_data.pulseRate)
        Utils.mergeBasicOldData(oldPulseOximeterData.sp02, local_data.sp02)
    }

    if (newPulseOximeterData !== undefined){
        if(newPulseOximeterData.length !== 0){
            let spo2_PrPi_Splitted_Data;
            for (var i = newPulseOximeterData.length-1; i >= 0; i--){        // Find new values and add it  
                isANewDateValue = local_data.pulseRate.find(xDate => { return xDate.x === new Date(newPulseOximeterData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){
                    spo2_PrPi_Splitted_Data = splitPrSpo2PiData(newPulseOximeterData[i].value); // separate Pr and Sp02 
                    if (spo2_PrPi_Splitted_Data[1] !== '511') {      // Filter non significant value                                                                        
                        local_data.pulseRate.push(  {x: new Date(newPulseOximeterData[i].eventDate).getTime(), y: spo2_PrPi_Splitted_Data[1]});
                    }
                    if (spo2_PrPi_Splitted_Data[0] !== '127') {      // Filter non significant value                                                                        
                        local_data.sp02.push(       {x: new Date(newPulseOximeterData[i].eventDate).getTime(), y: spo2_PrPi_Splitted_Data[0]});
                    }
                    if (spo2_PrPi_Splitted_Data[2] !== '511') {      // Filter non significant value                                                                        
                        local_data.pi.push(         {x: new Date(newPulseOximeterData[i].eventDate).getTime(), y: spo2_PrPi_Splitted_Data[2]});                                                                    
                    }
                }
            }
        }
    }
    return local_data;
}

 

//Function to get last good spO2 data
const getLastSpO2DataAndColor = (dataset, threshold, threshold2) => {

    let oximeterData = {
        spo2: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set spO2 val
        oximeterData.spo2 = dataset[dataset.length-1].y
        //Set spO2 val color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("spo2")
        }
        oximeterData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 2, 'inf', threshold2);
    }
    return (oximeterData);
}

//Function to get last pulse rate data
const getLastPulseRateDataAndColor = (dataset, threshold, threshold2) => {

    let pulseRateData = {
        pulseRate: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set pulse rate value
        pulseRateData.pulseRate = dataset[dataset.length-1].y
        //Set pulse rate color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("pulse_rate")
        }
        pulseRateData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 10, 'sup', threshold2);
    }
    return (pulseRateData);
}



//Const to import functions in other files
const PulseOximeterManager = {
  getLastSpO2DataAndColor,
  getLastPulseRateDataAndColor,
  formatAndMergeOximeterData
};

export default PulseOximeterManager;